window.arjoRichTextJs = window.arjoRichTextJs || {
  isInitialized: false,
  setExpander: function (richtext, mode) {
    const expanderId = richtext.getAttribute('data-expander');
    if (!expanderId) {
      return null;
    }

    const expander = document.getElementById(expanderId);
    if (!expander) {
      return;
    }

    var deactiveEvent = new Event(mode);
    expander.dispatchEvent(deactiveEvent);
  },
  expandEventHandler: function (richtext) {
    this.resizeEventHandler(richtext);
  },
  collapseEventHandler: function (richtext) {
    this.resizeEventHandler(richtext);
  },
  resizeEventHandler: function (richtext) {
    if (!richtext.hasAttribute('data-expand')) {
      const mode = richtext.scrollHeight > richtext.clientHeight + 1 ? 'active' : 'deactive';
      richtext.setAttribute('data-expander-mode', mode + 'd');

      if (richtext.scrollHeight > 0 && richtext.clientHeight === 0) {
        console.log("Browser doesn't support line clamp. Fallback to second mode.");
        richtext.setAttribute('data-expander-height-mode', '');
      }
      this.setExpander(richtext, mode);
    }
  },
  handleIFrames: function (richtextBlock) {
    const iFrameLoadHandler = (frame) => {
      try {
        frame.height = frame.contentWindow.document.documentElement.scrollHeight;
      } catch {}
    };
    var frames = richtextBlock.querySelectorAll('iframe');
    [].forEach.call(frames, (frame) => {
      frame.addEventListener('load', () => iFrameLoadHandler(frame));
      iFrameLoadHandler(frame);
    });
  },
  init: function () {
    if (this.isInitialized) {
      return;
    }

    this.isInitialized = true;

    const richtextBlocks = document.querySelectorAll('.arjo-m-rich-text');

    [].forEach.call(richtextBlocks, (richtextBlock) => {
      this.handleIFrames(richtextBlock);
      const richtext = richtextBlock.querySelector('.arjo-m-rich-text__content[data-expander]');
      if (!richtext) {
        return;
      }

      richtext.addEventListener('expand', () => this.expandEventHandler(richtext));
      richtext.addEventListener('collapse', () => this.collapseEventHandler(richtext));
      richtext.observeResize(() => this.resizeEventHandler(richtext));
      window.addEventListener('resize', () => this.resizeEventHandler(richtext));

      this.resizeEventHandler(richtext);
    });
  },
};

window.addEventListener('load', function () {
  window.arjoRichTextJs.init();
});
